import React, { useContext, useEffect, useState } from 'react';
import { getClientContracts } from 'app/api/contractApi';
import { ToastContext } from 'app/context/ToastContext';
import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import { Button } from 'primereact/button';
import { Divider } from 'primereact/divider';
import './contract-page.css';
import { useNavigate } from 'react-router-dom';

export const ContractPage = () => {
  const { showSuccess, showError } = useContext(ToastContext);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    getClientContracts()
      .then(r => {
        setData(r.data);
      })
      .catch(e => {
        console.error(e);
        showError('Chyba', e.response?.data?.detail);
      })
      .finally(() => setLoading(false));
  }, []);

  const onDetail = rowData => {
    navigate(`/contracts/${rowData.id}`);
  };

  const actionBodyTemplate = rowData => {
    return (
      <React.Fragment>
        <Button
          className="contract-detail"
          icon="pi pi-info-circle"
          type="button"
          rounded
          outlined
          severity="info"
          onClick={() => onDetail(rowData)}
        />
      </React.Fragment>
    );
  };

  return (
    <div>
      <h1 style={{ color: 'var(--primary-color)' }}>MOJE ZMLUVY</h1>

      <Divider className="client-divider" />
      <div className="flex">
        <div className="col-12 md:col-7">
          <DataTable
            stripedRows
            showGridlines={true}
            value={data}
            dataKey="id"
            paginator
            loading={loading}
            rows={5}
            totalRecords={data?.length}
            className="datatable-responsive client-datatable"
            emptyMessage="Žiadne zmluvy."
            responsiveLayout="scroll"
          >
            <Column field="product.name" header="PRODUKT" sortable headerStyle={{ minWidth: '12rem' }}></Column>
            <Column field="contractNr" header="ČÍSLO ZMLUVY" sortable></Column>
            <Column body={actionBodyTemplate} header="DETAIL" exportable={false} style={{ justifyContent: 'end' }}></Column>
          </DataTable>
        </div>
        <div style={{ width: '100%', marginTop: '0.5rem' }}>
          <div
            className="client-need-contact"
            style={{ color: 'white', paddingLeft: '5rem', paddingRight: '5rem', paddingTop: '7rem', paddingBottom: '7rem' }}
          >
            V PRÍPADE, ŽE POTREBUJETE POMÔCŤ, ALEBO PORADIŤ, KONTAKUJTE SVOJHO SPROSTREDKOVATEĽA, ALEBO INFOLINKU SPOLOČNOSTI NFA.
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContractPage;
